import { gql } from '@apollo/client'
import { useState, useEffect } from 'react'
import { Alert } from 'reactstrap'
import Spinner from '../Spinner/Spinner'
import MessageCard from '../MessageCard/MessageCard'
import AppObject from './AppObject'
import { OBJECT_QUERY } from '../../graphql.js'
import { makeInteger } from '../../utils'
import { handleGraphQLErrors } from '../../utils.js'

const OBJECT = gql(OBJECT_QUERY)

export default function AppObjectContainer(props) {
  console.log('AppObjectContainer rendered: ', props)
  const { objId, objActionId, parentObjectId, initialSource } = props

  const [objectData, setObjectData] = useState()
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    let mounted = true
    async function fetchData() {
      try {
        console.log('Fetching object data...')
        setSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: OBJECT, variables: { id: objId, actionId: objActionId, timeStamp: new Date() } })
        if (data.object) {
          if (mounted) {
            setObjectData(data.object)
          }
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
    fetchData()
    return (() => mounted = false)
  }, [objId, objActionId])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  
  if (spinner) {
    return <Spinner />  
  }
  
  if (objectData) {
    console.log('AppObjectContainer: ', objectData)
    let action = null
    if (objActionId) {
      // Get the action object from the object.type.userActions list
      if (objectData.type.userActions) {
        for (let anAction of objectData.type.userActions) {
          if (makeInteger(anAction.id) === makeInteger(objActionId)) {
            action = anAction
            break
          }
        }
      }
      if (!action) {
        return <MessageCard title="Action Error" message="You are not authorized to perform this action." />
      }
    }
    return <AppObject object={objectData} action={action} parentObjectId={parentObjectId} initialSource={initialSource} />
  }
  return ''
}
